module.exports = {"340323100":"城关镇","340323101":"王庄镇","340323102":"新马桥镇","340323103":"连城镇","340323104":"刘集镇","340323105":"任桥镇","340323106":"湖沟镇","340323107":"濠城镇","340323200":"石湖乡","340323201":"杨庙乡","340323202":"仲兴乡","340323400":"固镇开发区","340323401":"蚌埠铜陵产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340323.json
// module id = 1063
// module chunks = 0